import { push } from "connected-react-router";
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Col, Label } from "reactstrap";
import { GetCompanyDataResult as IGetCompanyDataResult } from '../../Interfaces/Interfaces';
import { Login, Logout } from '../../redux/actions/AuthActions';
import { ICompanyData, IStore } from '../../redux/constants';


const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.value,
    CompanyDataProps: state.CompanyData,
    history: state.history,
    URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme,
    location: state.router.location,
    CompanyData: state.auth.CompanyData,

});

const dispatchProps = { push, Login, Logout }
interface PaymentSuccessProps {
    lang: string;
    userData: any;
    push: any;
    URL: string;
    theme: any;
    t: any;
    CompanyDataProps: IGetCompanyDataResult;
    location: any;
    CompanyData: ICompanyData;

}

interface PaymentSuccessState {
}

class PaymentSuccess extends React.Component<PaymentSuccessProps, PaymentSuccessState> {
    state = {
      
    }
    render() {
        return (
            <div className="insideAccounts " >
                <div className="m20 ">
                    <div className="container">
                        <div className="row py-5 align-items-center">
                            <Col sm="10" md="10" lg="10" className="mx-auto d-table h-100 containerMsg2">
                                <div className=" text-center p10" >
                                    <img src={`https://prod01-cdn-yoonit.plugitapps.com/cdn/imgs/paymentSuccesful.png`} alt="" className="mt-3" />
                                    <div className="d-block mt-3 text-center m10 align-self-center justify-content-center">
                                        <Label className="text-Grey font-32 t-bold d-block mb-2"> {this.props.t('Payment Successful!')} </Label>
                                        <Label className="text-Grey font-24 d-block m-0"> {this.props.t("Your Deposit has been processed successfully")}</Label>
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

export default withTranslation()(connect(mapStateToProps, dispatchProps)(PaymentSuccess) as any) as any;